function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvg: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "bg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.411 35.047c6.298-2.859 12.105-1.559 15.14-2.936 3.035-1.378 8.617-6.016 2.28-19.978s-15.841-12.121-19.18-10.605c-15.632 7.094-9.395 38.581 1.76 33.519z",
    fill: "#efefef",
    "data-original": "#efefef",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "effect"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31 7.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-2c-.275 0-.5.224-.5.5s.225.5.5.5.5-.224.5-.5-.225-.5-.5-.5z",
    fill: "#c7c7c7",
    "data-original": "#a4afc1",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30.023 32.065h1v2.001h-1z",
    fill: "#c7c7c7",
    transform: "matrix(.707 -.707 .707 .707 -14.441 31.268)",
    "data-original": "#a4afc1",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.957 28h1v2h-1z",
    fill: "#c7c7c7",
    transform: "matrix(.707 -.707 .707 .707 -12.757 27.202)",
    "data-original": "#a4afc1",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m29.699 28.5h2v1h-2z",
    fill: "#c7c7c7",
    transform: "matrix(.707 -.707 .707 .707 -11.514 30.202)",
    "data-original": "#a4afc1",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.634 32.566h2v1h-2z",
    fill: "#c7c7c7",
    transform: "matrix(.707 -.707 .707 .707 -15.58 28.518)",
    "data-original": "#a4afc1",
    style: {},
    className: ""
  })))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "color"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 7.883-7.794 4.5v.558 10.119.558l7.794 4.5 7.75-4.474v-.584-10.119-.584z",
    fill: "#f3f3f1",
    "data-original": "#f3f3f1",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 9,
    fill: "#f5fffa",
    r: 2.25,
    "data-original": "#2fdf84",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 27,
    fill: "#f5fffa",
    r: 2.25,
    "data-original": "#2fdf84",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 25.794,
    cy: 13.5,
    fill: "#f5fffa",
    r: 2.25,
    "data-original": "#2fdf84",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 10.206,
    cy: 22.5,
    fill: "#f5fffa",
    r: 2.25,
    "data-original": "#2fdf84",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 25.794,
    cy: 22.5,
    fill: "#f5fffa",
    r: 2.25,
    "data-original": "#2fdf84",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 10.206,
    cy: 13.5,
    fill: "#f5fffa",
    r: 2.25,
    "data-original": "#2fdf84",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "shadow"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 9c0-.831.455-1.548 1.125-1.938-.332-.193-.713-.312-1.125-.312-1.243 0-2.25 1.007-2.25 2.25s1.007 2.25 2.25 2.25c.412 0 .793-.119 1.125-.312-.67-.39-1.125-1.107-1.125-1.938z",
    fill: "#d7d7d7",
    "data-original": "#00b871",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 27c0-.831.455-1.548 1.125-1.938-.332-.193-.713-.312-1.125-.312-1.243 0-2.25 1.007-2.25 2.25s1.007 2.25 2.25 2.25c.412 0 .793-.119 1.125-.312-.67-.39-1.125-1.107-1.125-1.938z",
    fill: "#d7d7d7",
    "data-original": "#00b871",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.096 14.625c-.619-1.073-.254-2.443.815-3.067-.672-.386-1.522-.422-2.242-.006-1.076.621-1.445 1.997-.823 3.073s1.997 1.445 3.073.823c.003-.002.005-.004.008-.006-.332-.191-.625-.461-.831-.817z",
    fill: "#d7d7d7",
    "data-original": "#00b871",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10.508 23.625c-.619-1.073-.254-2.443.815-3.067-.672-.386-1.522-.422-2.242-.006-1.076.621-1.445 1.997-.823 3.073s1.997 1.445 3.073.823c.003-.002.005-.004.008-.006-.333-.191-.626-.461-.831-.817z",
    fill: "#d7d7d7",
    "data-original": "#00b871",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.096 21.375c.206-.356.499-.626.831-.817-.003-.002-.005-.004-.008-.006-1.076-.621-2.452-.253-3.073.823s-.253 2.452.823 3.073c.72.416 1.569.38 2.242-.006-1.069-.624-1.434-1.994-.815-3.067z",
    fill: "#d7d7d7",
    "data-original": "#00b871",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10.508 12.375c.206-.356.499-.626.831-.817-.003-.002-.005-.004-.008-.006-1.076-.621-2.452-.253-3.073.823s-.253 2.452.823 3.073c.72.416 1.569.38 2.242-.006-1.069-.624-1.435-1.994-.815-3.067z",
    fill: "#d7d7d7",
    "data-original": "#00b871",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.47 24.348 4.297 2.481c.031-.4.155-.773.367-1.087l-3.679-2.124v-.558-10.119-.558l3.679-2.124c-.212-.314-.337-.687-.368-1.087l-4.297 2.481c.961.658 1.275 1.947.683 2.972-.416.721-1.172 1.115-1.948 1.115v4.519c.777.001 1.532.395 1.948 1.115.594 1.027.279 2.316-.682 2.974z",
    fill: "#d5dbe1",
    "data-original": "#d5dbe1",
    style: {},
    className: ""
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "regular"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.25 11.5h1.5v13h-1.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 12c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 30c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.499 17.25h13.001v1.5h-13.001z",
    transform: "matrix(.866 -.5 .5 .866 -6.589 11.413)",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.799 16.499c-1.037 0-2.048-.538-2.603-1.499-.827-1.433-.334-3.271 1.098-4.098 1.431-.825 3.271-.334 4.098 1.098.4.694.507 1.502.3 2.276s-.703 1.421-1.397 1.821c-.473.273-.987.402-1.496.402zm-.008-4.499c-.254 0-.512.065-.747.201-.716.414-.962 1.333-.549 2.049.412.715 1.332.961 2.049.549.347-.2.595-.523.698-.911.104-.387.051-.791-.149-1.138-.278-.48-.782-.75-1.302-.75z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10.211 25.501c-.261 0-.522-.034-.781-.104-.775-.207-1.421-.703-1.822-1.397s-.507-1.502-.3-2.276.703-1.421 1.397-1.821c.695-.4 1.502-.508 2.276-.3.774.207 1.421.703 1.821 1.397.827 1.433.334 3.271-1.098 4.098-.461.266-.974.403-1.493.403zm-.007-4.501c-.261 0-.517.067-.748.201-.347.2-.595.523-.698.91-.104.388-.051.792.149 1.139s.523.595.91.698c.389.104.791.051 1.139-.149.716-.414.962-1.333.549-2.049-.2-.347-.523-.595-.91-.698-.13-.035-.261-.052-.391-.052z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.25 11.499h1.5v13.001h-1.5z",
    transform: "matrix(.5 -.866 .866 .5 -6.588 24.59)",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25.789 25.501c-.52 0-1.032-.137-1.495-.403-1.432-.827-1.925-2.665-1.098-4.098.4-.694 1.047-1.19 1.821-1.397.774-.208 1.581-.101 2.276.3.694.4 1.19 1.047 1.397 1.821s.101 1.582-.3 2.276-1.047 1.19-1.821 1.397c-.257.07-.519.104-.78.104zm-.745-1.702c.347.2.748.254 1.139.149.387-.104.71-.352.91-.698s.254-.751.149-1.139c-.104-.387-.352-.71-.698-.91-.348-.199-.749-.255-1.139-.149-.387.104-.71.352-.91.698-.413.716-.167 1.635.549 2.049z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10.201 16.499c-.509 0-1.023-.129-1.495-.401-.694-.4-1.19-1.047-1.397-1.821s-.101-1.583.299-2.277c.827-1.432 2.665-1.923 4.098-1.098 1.432.827 1.925 2.665 1.098 4.098-.555.961-1.566 1.499-2.603 1.499zm.008-4.499c-.52 0-1.024.269-1.302.75-.2.347-.254.751-.149 1.138.104.387.352.71.698.911.716.413 1.636.167 2.049-.549s.167-1.635-.549-2.049c-.235-.136-.493-.201-.747-.201z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.631 8.15h1.5v4.524h-1.5z",
    transform: "matrix(.5 -.866 .866 .5 2.173 24.588)",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.119 24.839h4.524v1.5h-4.524z",
    transform: "matrix(.866 -.5 .5 .866 -9.797 14.621)",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m25 16.063h1.5v3.875h-1.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.357 9.662h4.524v1.5h-4.524z",
    transform: "matrix(.866 -.5 .5 .866 -3.382 8.206)",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.869 23.327h1.5v4.524h-1.5z",
    transform: "matrix(.5 -.866 .866 .5 -15.351 24.591)",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m9.5 16.063h1.5v3.875h-1.5z",
    fill: "#000000",
    "data-original": "#000000",
    style: {},
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworking);
export default __webpack_public_path__ + "static/media/networking.e8444a73843f8ca347e42e71de91fea1.svg";
export { ForwardRef as ReactComponent };